import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Headers } from '@angular/http';

import { AppServices } from './../../../app.services';
import { NotifyService } from './../../../addon/notify.service';

import * as _ from 'lodash';
import * as dot from 'dot-object';

declare var $:any;

@Component({
	selector: 'app-proposalview',
	templateUrl: './proposalview.component.html',
	styleUrls: ['./proposalview.component.css']
})
export class ProposalviewComponent implements OnInit {
	proposal;
	constructor(private router: Router, private activatedroute: ActivatedRoute, private appServices: AppServices, private notifyService: NotifyService) { }

	ngOnInit() {
		let code = this.activatedroute.snapshot.params['code'];
		this.loadProposal(code);
	}
	ngAfterViewChecked() {
		$('.text-justify img').addClass('img-fluid');
	}
	assign(frm, data) {
		$.each(data, function(key){
			frm[key] = data[key];
		})
	}

	loadProposal(code) {
		this.appServices.api('Crmproposals/find', {
			'filter': `{"where":{"deleted":false, "code":"${code}"},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			if(res.length > 0) {
				obj.component.proposal = res[0];
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}

}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/proposal/proposalview/proposalview.component.ts